<template>
  <section
    class="ugc-new-confirm-design"
  >
    <div v-if="showStepsView" class="ugc-new-confirm-design-steps-view-wrapper">
      <ugc-new-steps-view></ugc-new-steps-view>
    </div>
    <div class="ugc-new-confirm-design-spinner text-center">
      <base-spinner
        ref="spinner"
        :set-spinner-default="showSpinner"
        size="60"
        position="initial"
      ></base-spinner>
    </div>
    <div class="ugc-new-confirm-design-image-wrapper">
      <img
        v-if="compositeImgKey"
        :src="imagesPreview[compositeImgKey].imgSrc"
        :alt="pdm.product_name"
        @load="onPreviewImageLoaded"
      />
    </div>
  </section>
</template>

<script>
import baseSpinner from '@/components/Spinner';
import UgcNewStepsView from "@/components/UGC/UGCMainComponents/NewTopBar/NewStepsView";
import ugc from '@/mixins/UGC';

export default {
  name: "UgcNewConfirmDesign",
  components: {
    baseSpinner,
    UgcNewStepsView,
  },
  mixins: [ugc],
  props: {
    showStepsView: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    }
  },
  watch: {
    showSpinner(show) {
      this.$refs.spinner.hideSpinner(!show);
    },
  },
  created() {
    this.$eventBus.$on("show-spinner-finish", this.setIsApplyingUGC);
    this.$eventBus.$emit("show-finish-button", true);

    this.$emit('showCtaButton', true);
    this.$emit('showIconButton', false);
    this.$emit('showBackButton', true);

    this.getUgcConfirmDesignImages();
  },

  mounted() {
    let action = this.checkerboarderActive ? 'checkerboarder' : 'ugc';
    if (this.$store.state.transferDesign.isCustomizerTransferredModel)
      action = 'transferDesign';
    else if (this.activeUGCIndex === 1)
      action = 'imageLibrary';
    this.$ugcDataLayer.logAnalyticsEvent({
      action,
      type: this.$ugcDataLayer.types.designLoaded
    });
    this.$refs.spinner.hideSpinner(false);
    this.$store.commit("ugc/stateManager/SET_LOADING", true);
  },

  beforeDestroy() {
    this.$eventBus.$emit("show-finish-button", false);
    this.$eventBus.$off("show-spinner-finish", this.setIsApplyingUGC);
  }
};
</script>
